var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"memberName"},[_vm._v("\n    "+_vm._s(_vm.before_text)+_vm._s(_vm.memberName)+_vm._s(_vm.after_text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }